import React from 'react';
import PropTypes from 'prop-types';
import { TRANSLATION_KEY } from '../constants';
import { summarizeAndroidValidation } from '../utils';
import css from '../style.css';

const ANDROID_KEY = `${TRANSLATION_KEY}.ANDROID`;

const pluralKey = (base, count) => `${base}.${count === 1 ? 'ONE' : 'OTHER'}`;

const AndroidValidationOverview = ({ androidValidation, translate }) => {
    const { withKeyCount, withoutKeyCount, notSupportingKeyCount } = summarizeAndroidValidation(androidValidation);

    return (
        <div className={css.androidOverview}>
            <div className={css.separator} />
            <div>{translate(`${ANDROID_KEY}.INTRO`, null, { renderInnerHtml: true })}</div>
            <h5 className={css.overviewHeading}>{translate(`${ANDROID_KEY}.OVERVIEW_HEADING`)}</h5>

            <div className={css.overviewLine}>
                {translate(pluralKey(`${ANDROID_KEY}.ENHANCED`, withKeyCount), { count: withKeyCount })}
            </div>

            {withoutKeyCount > 0 && (
                <div className={css.overviewLine}>
                    {translate(
                        pluralKey(`${ANDROID_KEY}.BASIC`, withoutKeyCount),
                        { count: withoutKeyCount },
                        { renderInnerHtml: true }
                    )}
                </div>
            )}

            {notSupportingKeyCount > 0 && (
                <div className={css.overviewLine}>
                    {translate(pluralKey(`${ANDROID_KEY}.OUTDATED`, notSupportingKeyCount), {
                        count: notSupportingKeyCount,
                    })}
                </div>
            )}
        </div>
    );
};

AndroidValidationOverview.propTypes = {
    androidValidation: PropTypes.shape({
        sites_with_keys: PropTypes.arrayOf(PropTypes.string),
        sites_without_keys: PropTypes.arrayOf(PropTypes.string),
        not_supporting_sites: PropTypes.arrayOf(PropTypes.string),
    }),
    translate: PropTypes.func.isRequired,
};

export default AndroidValidationOverview;
